<template>
  <div class="c-textarea">
    <label class="c-textarea__label" :for="'textarea' + type">{{ title }}</label>
    <textarea
      class="c-textarea__field"
      rows="3"
      :title="title"
      :id="'textarea' + type"
      :maxlength="textareaSize"
      v-model="text"
      @keyup="change"
    />
    <span class="c-textarea__note">{{ note }}</span>
  </div>
</template>
<script>
// @ is an alias to /src
export default {
  name: 'TextArea',
  data() {
    return {
      title: this.dataTitle ? this.dataTitle : '',
      note: this.dataNote ? this.dataNote : '',
      type: this.dataType ? this.dataType : '',
      textareaSize: this.dataTextareaSize ? this.dataTextareaSize : 400,
      text: this.dataText ? this.dataText : ''
    };
  },
  props: {
    dataTitle: String,
    dataNote: String,
    dataType: String,
    dataTextareaSize: Number,
    dataText: String
  },
  methods: {
    change() {
      this.$emit('childToParent', this.text);
    }
  }
};
</script>
<style lang="scss">
@import '@/assets/scss/essentials/essentials.scss';
@import './textarea';
</style>
